module.exports = __webpack_public_path__ + "static/img/tow.1ba08d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elephant/tow.png
// module id = OfjO
// module chunks = 1